'use client'

import Link from 'next/link'

import Skeleton from '@mui/material/Skeleton'
import Typography from '@mui/material/Typography'

import BamaRecordPreview from '@components/BamaRecordPreview'
import type { RecordSummaryWithLink } from '@/hooks/useRecordSummary'

export const RECORD_SKELETON_WIDTH = 64

type BamaRecordTitleProps = {
  title: string
  record: RecordSummaryWithLink

  // Título para módulos sin código, donde el nombre ya dice de qué registro es y el "de este X" sobra.
  titleWhenNamed?: string
}

// Título de pestaña "CÓDIGO : título"; el código enlaza al registro y muestra su vista previa al pasar el cursor.
const BamaRecordTitle = ({ title, record, titleWhenNamed }: BamaRecordTitleProps) => {
  const identifier = record.code || record.name

  if (record.loading) {
    return (
      <>
        <Skeleton component='span' variant='text' width={RECORD_SKELETON_WIDTH} className='inline-block align-middle' />
        {` : ${titleWhenNamed ?? title}`}
      </>
    )
  }

  if (!identifier) return <>{title}</>

  return (
    <>
      <BamaRecordPreview record={record}>
        <Typography component={Link} href={record.href} variant='inherit' color='primary' className='hover:underline'>
          {identifier}
        </Typography>
      </BamaRecordPreview>
      {` : ${!record.code && titleWhenNamed ? titleWhenNamed : title}`}
    </>
  )
}

export default BamaRecordTitle
